import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { RestHelper } from '../helper/restHelper';

const GeneralGroupFileUpload = (data) => {
  const [files, setFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  const [uploading, setUploading] = useState(false);
  const [fileStatus, setFileStatus] = useState({});
  const [countdown, setCountdown] = useState(null);
  const [uploadInfo, setUploadInfo] = useState({})
  const [fileInfo, setFile] = useState({})
  const [isMounted, setIsMounted] = useState(false)
  const [uploadUrl, setUploadUrl] = useState({})
  const [indexTracker, setIndexTracker] = useState()
  const [uploadResponse, setUploadResponse] = useState()
  const [showLoading, setShowLoading] = useState(false)
  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const env = process.env.REACT_APP_ENVIRONMENT;

  const api = RestHelper()
  const downloadIcon = '/img/file-upload-64.png';
  const loadingIcon = '/img/icons8-loading.gif'
  const dropZoneStyle1 = {
    border: '2px dashed #007bff',
    borderRadius: '10px',
    padding: '20px',
    textAlign: 'center',
    color: '#007bff',
    cursor: 'pointer',
    backgroundColor: '#f9f9f9',
  };

  const dropZoneStyle2 = {
    border: '2px solid #666',       // Medium gray border
    borderRadius: '5px',
    padding: '20px',
    textAlign: 'center',
    color: '#333',                  // Darker text color for contrast
    cursor: 'pointer',
    backgroundColor: '#ddd',        // Medium gray background
  };

  const dropZoneStyle3 = {
    border: '2px solid #ccc',
    borderRadius: '8px',
    padding: '20px',
    textAlign: 'center',
    color: '#fff',
    cursor: 'pointer',
    background: 'linear-gradient(135deg, #6d5dfc, #bb34ef)',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  };

  const browseButtonStyle = {
    display: 'inline-block',
    padding: '10px 20px',
    borderRadius: '20px',          // Fully rounded button
    backgroundColor: '#007bff',    // Button background color (Bootstrap blue)
    color: '#fff',                 // Text color
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'none',        // Remove any underline from the button text
    fontSize: '16px',
    marginTop: '10px',
  };

  const browseButtonStyleDisabled = {
    display: 'inline-block',
    padding: '10px 20px',
    borderRadius: '20px',          // Fully rounded button
    backgroundColor: '#fff',    // Button background color (Bootstrap blue)
    color: '#007bff',                 // Text color
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'none',        // Remove any underline from the button text
    fontSize: '16px',
    marginTop: '10px',
  };

  useEffect(() => {
    if(isMounted && files.length > 0){
        setUploading(true)
        handleUpload()
    }
  },[files,setFiles])

 useEffect(() => {
    if (isMounted) {
    const doUpload = async () => {
    const index = indexTracker
    console.log('Current index tracker is ', index)
    console.log(uploadResponse[index].response, uploadResponse[index].file_info)
    const formData = new FormData()
            const key = uploadResponse[index].response.fields['key']
            const keyId = uploadResponse[index].response.fields['AWSAccessKeyId']
            const policy = uploadResponse[index].response.fields['policy']
            const token = uploadResponse[index].response.fields['x-amz-security-token']
            const signature = uploadResponse[index].response.fields['signature']
            formData.append('key', key)
            formData.append('AWSAccessKeyId', keyId)
            formData.append('policy', policy)
            formData.append('x-amz-security-token', token)
            formData.append('signature', signature)
            formData.append('file', uploadResponse[index].file_info)

            const config = {
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                if (percentCompleted<100){
                    setUploading(true)
                }
                setUploadProgress((prevProgress) => ({
                    ...prevProgress,
                    [uploadResponse[index].file_info.name]: percentCompleted,
                }));
                if (percentCompleted===100){
                    setUploading(false)
                }
            },
        }

            try {
            await axios.post(uploadUrl[index], formData, config);
            setFileStatus(prev => ({ ...prev, [uploadResponse[index].file_info.name]: 'complete' }));
        } catch (error) {
            console.error(`Error uploading file ${uploadResponse[index].file_info.name}`, error);
            setFileStatus(prev => ({ ...prev, [uploadResponse[index].file_info.name]: 'error' }));
        }
    }
    doUpload();
    }
    else {
        setIsMounted(true)
    }

 },[uploadResponse, setUploadResponse])

 // Auto-refresh file list once all uploads are complete or errored
 useEffect(() => {
    if (files.length === 0) return;
    const allComplete = files.every(
        f => fileStatus[f.name] === 'complete' || fileStatus[f.name] === 'error'
    );
    if (allComplete) {
        setCountdown(6);
        const interval = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    data.clearResponseMessage();
                    setFiles([]);
                    setFileStatus({});
                    setUploadProgress({});
                    setUploading(false);
                    setCountdown(null);
                    return null;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }
 }, [fileStatus, files]);

 function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
// Handle file drop
const onDrop = (e) => {
    e.preventDefault(); // Prevent default behavior (open file in browser)
    e.stopPropagation();
    setUploading(true)
    let droppedFiles = Array.from(e.dataTransfer.files);
    // Limit to 5 files at a time
    if (droppedFiles.length > 5) {
      alert('You can only upload up to 5 files at a time.');
    } else {
      setFiles(droppedFiles);
    }
  };

  const setResponseInfo = (res, index, file) => {
    console.log(index, res)
    //fileUpload(res, index)
    setIndexTracker(index)
    setUploadUrl(prev => ({
        ...prev,
        [index]: res.url
    }))
    setUploadResponse(prev => ({
        ...prev,
        [index]: {'response': res, 'file_info': file}
    }))
 
    
  }

  const clearProgressBar = () => {
    setFiles([])
    setShowLoading(true)
    sleep(2000).then(() => {clearResponseMessage()});
  }

  const clearResponseMessage = () => {
    {data.clearResponseMessage()}
    setShowLoading(false)
  }

  // Handle file selection via input field
  const onFileSelect = (e) => {
    let selectedFiles = Array.from(e.target.files);
    // Limit to 5 files at a time
    if (selectedFiles.length > 5) {
      alert('You can only upload up to 5 files at a time.');
    } else {
      setFiles(selectedFiles);
    }
  };

  useEffect(() => {
    // Prevent the default behavior across the entire document to avoid file opening
    const preventDefault = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    document.addEventListener('dragover', preventDefault);
    document.addEventListener('drop', preventDefault);

    return () => {
      document.removeEventListener('dragover', preventDefault);
      document.removeEventListener('drop', preventDefault);
    };
  }, []);

  // Prevent default behavior when dragging files over the drop zone
  const onDragOver = (e) => {
    e.preventDefault(); // Prevent default behavior (open file)
    e.stopPropagation();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
  }
  // Get a signed URL from your AWS API
  const getSignedUrl = async (file) => {
    try {
      const response = await axios.post('/upload-file-admin', { 'unique_id': data.requestId, 'file_name': file.name });
      return response.data.url;
    } catch (error) {
      console.error('Error getting signed URL', error);
      return null;
    }
  };

  const uploadHandler = (file, index) => {
    console.log('Index is currently', index)
    const options = {}
    const fileData = {'unique_id' : data.requestId, 'file_name' : file.name }
    api
        .postCreate('/upload-file-admin', options, fileData)
        .then(res => setResponseInfo(res, index, file))
        .catch(err => console.log(err))
    return
  }

  // Upload file to S3
  const uploadFile = async (file, index) => {
    console.log(file, index)
    //setFile(file)
    setFile({
        ...fileInfo,
        [index]: file
    })
    const signedUrl = await uploadHandler(file, index);
    console.log(signedUrl)
    if (!signedUrl) return;



  };

  // Handle file upload process
  const handleUpload = async () => {
    setUploading(true);
    const promises = files.map((file, index) => uploadFile(file, index));
    await Promise.all(promises);
    //setUploading(false);
  };

  return (
    <div className="mb-6">
      <h4 className="text-base font-semibold text-neutral-800 mb-3">Upload New Files</h4>

      {/* Drop Zone */}
      <div
        className={`border-2 border-dashed rounded-lg p-6 text-center transition-colors ${
          uploading
            ? 'border-neutral-200 bg-neutral-100 cursor-not-allowed opacity-60'
            : isDragging
              ? 'border-blue-500 bg-blue-50 cursor-pointer'
              : 'border-neutral-300 bg-neutral-50 hover:border-blue-400 hover:bg-blue-50/50 cursor-pointer'
        }`}
        onDragOver={uploading ? undefined : handleDragOver}
        onDragLeave={uploading ? undefined : handleDragLeave}
        onDrop={uploading ? (e) => e.preventDefault() : onDrop}
      >
        <div className="flex flex-col items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" className={`h-10 w-10 ${uploading ? 'text-neutral-300' : 'text-neutral-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
          <p className={uploading ? 'text-neutral-400' : 'text-neutral-600'}>{uploading ? 'Upload in progress...' : 'Drag & Drop files here to upload (5 files max)'}</p>
          {!uploading && <p className="text-neutral-400 text-sm">OR</p>}
          {/* Hidden file input */}
          <input
            type="file"
            multiple
            onChange={onFileSelect}
            className="hidden"
            id="fileInput"
            accept="*/*"
            disabled={uploading}
          />
          {!uploading && (
            <label htmlFor="fileInput" className="cursor-pointer text-blue-600 hover:text-blue-800 font-medium hover:underline">
              Click to Browse Files
            </label>
          )}
        </div>
      </div>

      {/* Selected Files List with Progress */}
      {files.length > 0 && (
        <div className="mt-4 space-y-3">
          {files.map((file) => (
            <div key={file.name} className="bg-neutral-50 rounded-lg p-3 border border-neutral-200">
              {fileStatus[file.name] === 'complete' ? (
                <div className="flex items-center gap-2 text-green-600">
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="font-medium">{file.name}</span>
                  <span className="text-sm text-neutral-500">— Upload complete, verification pending</span>
                </div>
              ) : fileStatus[file.name] === 'error' ? (
                <div className="flex items-center gap-2 text-red-600">
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  <span className="font-medium">{file.name}</span>
                  <span className="text-sm">— Upload failed</span>
                </div>
              ) : (
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-neutral-700 truncate">{file.name}</span>
                    <span className="text-sm text-neutral-500">{uploadProgress[file.name] || 0}%</span>
                  </div>
                  <div className="w-full bg-neutral-200 rounded-full h-2">
                    <div
                      className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                      style={{ width: `${uploadProgress[file.name] || 0}%` }}
                    />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {countdown !== null && (
        <div className="mt-3 text-sm text-neutral-500">
          Refreshing file list in {countdown}s...
        </div>
      )}
    </div>
  );
};

export default GeneralGroupFileUpload;
